import useApi from 'helpers/api';
import useNotification from 'hooks/useNotification';
import { useEffect, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import CustomerContactsService from 'services/CustomerContacts.service';
import TicketsService from 'services/Tickets.service';

const TicketContactEditModal = ({
  show,
  close,
  ticket,
  setContact,
  refreshTicket
}) => {
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const api = useApi();
  const [contacts, setContacts] = useState([]);
  const [body, setBody] = useState({
    contactCustomer: { id: 0 }
  });

  const customerId = ticket.customer?.id;
  const isDisabledForm =
    ticket.status?.status == 'COMPLETED' || ticket.status?.status == 'CLOSED';

  useEffect(() => {
    getContacts();
  }, [customerId]);

  useEffect(() => {
    setBody({ contactCustomer: { id: parseInt(ticket.contactCustomer?.id) } });
  }, [ticket]);

  const getContacts = async () => {
    const filter = {
      page: 0,
      size: 100
    };
    const queryParams = new URLSearchParams(filter).toString();
    if (customerId) {
      let response = await CustomerContactsService.list(
        customerId,
        queryParams
      );
      setContacts(response.content);
    }
  };

  const editContact = async e => {
    setBody({ contactCustomer: { id: parseInt(e.target.value) } });
    const response = await TicketsService.edit(ticket?.id, {
      contactCustomer: { id: parseInt(e.target.value) }
    });

    if (response.id) {
      setBody({
        contactCustomer: { id: parseInt(response.contactCustomer?.id) }
      });
      setContact(response?.contactCustomer);
      showSuccessNotification('Contato alterado com sucesso');
      refreshTicket();
      close();
    } else {
      showErrorNotification('Erro ao alterar contato: ' + response.userMessage);
    }
  };

  return (
    <Modal show={show} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title>Alterar contato</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="editForm.Name">
            <Form.Label>
              Contato <span className="text-danger"> *</span>
            </Form.Label>
            <Form.Select
              value={body.contactCustomer?.id}
              onChange={editContact}
              size="sm"
              disabled={isDisabledForm}
            >
              {contacts.map(item => (
                <option value={item.id} key={item.name}>
                  {item.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default TicketContactEditModal;
